import type * as React from "react"

/** What a search announces: nothing before the first keystroke, then the count. */
export function resultCountMessage(query: string, count: number): string {
  if (query.trim() === "") {
    return ""
  }
  return `${count} ${count === 1 ? "result" : "results"}`
}

export interface SearchResultsStatusProps {
  /**
   * The menu's visible empty state, shown while nothing matches. It lives in
   * the region so its text exists once and is announced when it appears.
   */
  emptyState?: React.ReactNode
  /** Read while the empty state is hidden, usually `resultCountMessage`. */
  announcement: string
}

/**
 * A polite live region that tells a screen reader what a search left, since
 * filtering a list moves nothing into focus. Mounted with the menu and quiet
 * until the first keystroke, so opening the menu announces nothing and each
 * change of the query announces once.
 */
export function SearchResultsStatus({
  emptyState,
  announcement,
}: SearchResultsStatusProps) {
  return (
    <div role="status" aria-live="polite">
      {emptyState ?? <span className="sr-only">{announcement}</span>}
    </div>
  )
}
